import styled from '@emotion/styled'
import { MultilingualKeyDto } from '@pharmac-extranet/extranet-api'
import { MediaQuery, useLanguage } from '@pharmac-extranet/shared'
import { PharmacIconProps } from '@pharmac/ui'
import { RouterPaths } from '../../router/i18n/extranet-routes'
import { FrontpageShortcut } from './FrontpageShortcut'

const FrontpageShortcutsRoot = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  height: 300px;

  ${MediaQuery.maxTablet} {
    padding: var(--spacing-small) var(--spacing-large);
    flex-direction: row;
    height: calc(150px + var(--spacing-medium));
    margin-bottom: var(--spacing-small);
    width: 100%;
  }

  @media (max-width: 600px) {
    height: 300px;
    margin: 0 auto;
  }
`

type ShortcutItem = {
  id: string
  title: MultilingualKeyDto
  icon: PharmacIconProps['icon']
  url: keyof RouterPaths
}

const shortcuts: ShortcutItem[] = [
  {
    id: crypto.randomUUID(),
    title: {
      fi: 'Valmiste&shy;valikoima',
      sv: 'Läkemedels&shy;sortiment',
      en: 'Range of products',
    },
    icon: 'capsuleAndPill',
    url: 'oma-annos.dispensedProducts',
  },
  {
    id: crypto.randomUUID(),
    title: {
      fi: 'Tuote&shy;puutokset',
      sv: 'Läkemedels&shy;brister',
      en: 'Shortages',
    },
    icon: 'alertCircle',
    url: 'oma-annos.orders.productShortages',
  },
  {
    id: crypto.randomUUID(),
    title: {
      fi: 'Tilaus&shy;historia',
      sv: 'Beställnings&shy;historik',
      en: 'Order history',
    },
    icon: 'list',
    url: 'oma-annos.orders',
  },
  {
    id: crypto.randomUUID(),
    title: {
      fi: 'UKK',
      en: 'FAQ',
      sv: 'Vanliga frågor',
    },
    icon: 'helpCircle',
    url: 'support.faq',
  },
]

export const FrontpageShortcuts = () => {
  const { key } = useLanguage()

  return (
    <FrontpageShortcutsRoot>
      {shortcuts.map((a) => (
        <FrontpageShortcut
          key={a.id}
          title={key(a.title)}
          icon={a.icon}
          url={a.url}
        />
      ))}
    </FrontpageShortcutsRoot>
  )
}
